import React from 'react';
import { MessageCircle, FileText, TrendingUp, ArrowRight } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    id: 1,
    title: 'Free Consultation',
    description: 'We meet to understand your financial goals and current situation. No pressure, just a friendly chat.',
    icon: MessageCircle,
    color: 'bg-blue-100 text-blue-600'
  }, {
    id: 2,
    title: 'Custom Plan',
    description: 'We build a personalized investment strategy tailored to your budget and risk comfort.',
    icon: FileText,
    color: 'bg-emerald-100 text-emerald-600'
  }, {
    id: 3,
    title: 'Guided Growth',
    description: 'Start investing with our ongoing support. We teach you as you grow your portfolio.',
    icon: TrendingUp,
    color: 'bg-purple-100 text-purple-600'
  }];
  return <section id="how-it-works" className="py-24 bg-white" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="text-center mb-16" data-id="element-105">
          <h2 className="text-emerald-600 font-semibold tracking-wide uppercase text-sm mb-2" data-id="element-106">
            Simple Process
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-107">
            Investing made easy as 1-2-3
          </h3>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-108">
            Forget complicated charts and jargon. We guide you through a simple,
            proven process designed for beginners.
          </p>
        </div>

        <div className="relative" data-id="element-109">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-0.5 bg-gray-100 -z-10" data-id="element-110">
            <div className="absolute top-0 left-[16%] right-[16%] h-full border-t-2 border-dashed border-emerald-200" data-id="element-111"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-12" data-id="element-112">
            {steps.map((step, index) => <div key={step.id} className="relative flex flex-col items-center text-center group" data-id="element-113">
                <div className={`w-24 h-24 rounded-full ${step.color} flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300 relative bg-white border-4 border-white`} data-id="element-114">
                  <step.icon className="h-10 w-10" data-id="element-115" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center font-bold border-2 border-white" data-id="element-116">
                    {step.id}
                  </div>
                </div>

                <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-117">
                  {step.title}
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-118">
                  {step.description}
                </p>

                {index < steps.length - 1 && <div className="md:hidden mt-8 text-emerald-300" data-id="element-119">
                    <ArrowRight className="h-8 w-8 mx-auto transform rotate-90" data-id="element-120" />
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}